<header class="heading">
  <div>
    <h1>Envíos programados</h1>
    <p>Consulta los envíos y recordatorios de todos los clientes</p>
  </div>
  <div class="actions">
    <button type="button" [disabled]="loading" (click)="load(); loadUsers()">
      Actualizar</button
    ><button
      class="primary"
      type="button"
      [disabled]="exporting || loading || !total"
      (click)="exportCsv()"
    >
      {{ exporting ? "Exportando..." : "Exportar CSV" }}
    </button>
  </div>
</header>
@if (error) {
  <p class="error" role="alert">{{ error }}</p>
}
@if (optionsError) {
  <p class="error" role="alert">{{ optionsError }}</p>
}
<section class="stats">
  <div>
    <span>En cola</span><strong>{{ stats.queued }}</strong>
  </div>
  <div>
    <span>Destinatarios pendientes</span><strong>{{ stats.recipients }}</strong>
  </div>
  <div>
    <span>Costo estimado en cola</span
    ><strong>S/ {{ stats.estimated_cost | number: "1.2-2" }}</strong>
  </div>
  <div>
    <span>Próximo envío</span
    ><strong class="next">{{ date(stats.next_at) }}</strong>
  </div>
</section>
<section class="card">
  <div class="toolbar">
    <nav aria-label="Secciones de programados">
      @for (t of tabs; track t.key) {
        <button
          type="button"
          [class.active]="tab === t.key"
          [attr.aria-pressed]="tab === t.key"
          (click)="tab = t.key; filter()"
        >
          {{ t.label }}
        </button>
      }
    </nav>
    <div class="filters">
      <label
        >Cliente<select
          aria-label="Filtrar por cliente"
          [(ngModel)]="userId"
          (ngModelChange)="filter()"
        >
          <option value="">Todos los clientes</option>
          @for (u of users; track u.id) {
            <option [value]="u.id">{{ u.label }}</option>
          }
        </select></label
      ><label
        >Buscar<input
          placeholder="Nombre, cliente o email"
          [(ngModel)]="search"
          (ngModelChange)="searchChanged()" /></label
      ><label
        >Estado<select [(ngModel)]="status" (ngModelChange)="filter()">
          <option value="">Todos los estados</option>
          @for (s of statuses | keyvalue; track s.key) {
            <option [value]="s.key">{{ s.value }}</option>
          }
        </select></label
      ><label
        >Modalidad<select [(ngModel)]="mode" (ngModelChange)="filter()">
          <option value="">Todas las modalidades</option>
          @for (m of modes | keyvalue; track m.key) {
            <option [value]="m.key">{{ m.value }}</option>
          }
        </select></label
      ><button type="button" (click)="clear()">Limpiar</button>
    </div>
  </div>
  @if (loading) {
    <p class="notice" role="status">Cargando programados...</p>
  }
  <div class="table-wrap">
    <table>
      <thead>
        <tr>
          <th>Programado para</th>
          <th>Cliente</th>
          <th>Nombre</th>
          <th>Modalidad</th>
          <th>Destinatarios</th>
          <th>Estado</th>
          <th>Enviados / Fallidos</th>
          <th>Costo registrado</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (i of items; track i.id) {
          <tr>
            <td>
              {{ date(i.scheduled_at) }}
              @if (overdue(i)) {
                <small class="late">Atrasado</small>
              }
            </td>
            <td>
              <strong>{{ i.client?.full_name || "Sin nombre" }}</strong
              ><small>{{ i.client?.email }}</small>
            </td>
            <td>{{ i.name || "Sin nombre" }}</td>
            <td>{{ modes[i.mode] }}</td>
            <td>{{ i.total_recipients }}</td>
            <td>
              <span class="badge" [attr.data-status]="i.status">{{
                statuses[i.status]
              }}</span>
            </td>
            <td>
              <span class="sent">{{ i.sent_count }}</span> /
              <span class="late">{{ i.failed_count }}</span>
            </td>
            <td>{{ i.actual_cost }} créditos</td>
            <td>
              <button type="button" (click)="open(i)">Ver detalle</button>
            </td>
          </tr>
        }
        @if (!loading && !items.length) {
          <tr>
            <td colspan="9" class="empty">
              No hay envíos con los filtros seleccionados.
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <footer>
    <div class="pagination-summary">
      <span>Mostrando {{ total ? (page - 1) * pageSize + 1 : 0 }}-{{ (page - 1) * pageSize + items.length }} de {{ total }} envíos</span>
      <label>
        Ver
        <select [value]="pageSize" (change)="changePageSize(+$any($event.target).value)" aria-label="Envíos por página">
          @for (size of pageSizeOptions; track size) {
            <option [value]="size">{{ size }}</option>
          }
        </select>
        por página
      </label>
    </div>
    <div class="actions">
      <button
        type="button"
        [disabled]="loading || page === 1"
        (click)="page = page - 1; load()"
      >
        Anterior</button
      ><span>Página {{ page }} de {{ totalPages }}</span
      ><button
        type="button"
        [disabled]="loading || page === totalPages"
        (click)="page = page + 1; load()"
      >
        Siguiente
      </button>
    </div>
  </footer>
</section>
@if (selected; as i) {
  <div class="backdrop" (click)="close()">
    <section
      class="schedule-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="scheduled-title"
      (click)="$event.stopPropagation()"
    >
      <header>
        <div>
          <h2 id="scheduled-title">{{ i.name || "Detalle del envío" }}</h2>
          <p>{{ i.client?.full_name }} · {{ i.client?.email }}</p>
        </div>
        <button
          id="scheduled-close"
          type="button"
          aria-label="Cerrar detalle"
          (click)="close()"
        >
          ×
        </button>
      </header>
      <div class="detail-grid">
        <div>
          <span>Estado</span><strong>{{ statuses[i.status] }}</strong>
        </div>
        <div>
          <span>Modalidad</span><strong>{{ modes[i.mode] }}</strong>
        </div>
        <div>
          <span>Programado</span><strong>{{ date(i.scheduled_at) }}</strong>
        </div>
        <div>
          <span>Creado</span><strong>{{ date(i.created_at) }}</strong>
        </div>
        <div>
          <span>Enviados / Fallidos</span
          ><strong>{{ i.sent_count }} / {{ i.failed_count }}</strong>
        </div>
        <div>
          <span>Costo estimado</span
          ><strong>S/ {{ i.estimated_cost | number: "1.2-2" }}</strong>
        </div>
        <div>
          <span>Consumo registrado</span
          ><strong>{{ i.actual_cost }} créditos</strong>
        </div>
        <div>
          <span>Procesado</span><strong>{{ date(i.processed_at) }}</strong>
        </div>
        @if (i.appointment_at) {
          <div>
            <span>Fecha de cita</span
            ><strong>{{ date(i.appointment_at) }}</strong>
          </div>
          <div>
            <span>Anticipación</span
            ><strong>{{ i.reminder_days_before }} días</strong>
          </div>
        }
      </div>
      @if (i.error_message) {
        <p class="error">{{ i.error_message }}</p>
      }
      <h3>Destinatarios ({{ i.total_recipients }})</h3>
      <div class="recipients">
        @for (r of i.recipients; track $index) {
          <article>
            <strong>{{ r.phone }}</strong>
            <p>{{ r.message }}</p>
          </article>
        }
      </div>
      <p class="notice">
        “Enviado” indica que el proveedor aceptó el mensaje; no confirma su
        entrega. Consulta Campañas o Historial para verificarla.
      </p>
    </section>
  </div>
}
